import { useEffect, useRef } from 'react';
import { vibratePreset, type HapticPatternName } from '../../../audio/haptics';

/**
 * Foundation helper: useMountVibrate（R2 Wave3B・2026-06-21）
 *
 * useMountSound の触覚版。「このコンポーネントが表示された瞬間に振動を 1 回」鳴らす。
 * JudgementModal（success）/ FailOverlay（fail）が、音（useMountSound）の隣に並べて使う。
 *
 * 設計上の肝（useMountSound と同一方針・二重発火を構造的に防ぐ）:
 *  - haptics モジュールが feature-detect / ユーザー設定 / 例外を全て吸収するため、
 *    ここでは条件判定不要（非対応端末・OFF 時は vibratePreset が安全に no-op）。
 *  - **React StrictMode の二重 mount** で二重に震えないよう playedRef ガードを張る
 *    （useMountSound と完全に同じガード形）。
 *  - `enabled` が false→true に変わった最初のレンダで 1 回だけ発火する
 *    （例: JudgementModal は type==='success' の時だけ震わせる）。
 *
 * 音と独立したフックにしてあるのは、音だけ / 振動だけ無効でも他方が壊れないため。
 * 同じ mount 点に 2 つ並べることで「音と振動が同時に立つ」体験を作る。
 */
export function useMountVibrate(name: HapticPatternName, enabled = true): void {
  const playedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;
    if (playedRef.current) return;
    playedRef.current = true;
    vibratePreset(name);
    // enabled を依存に含め、false→true の遷移で 1 回だけ発火できるようにする。
  }, [enabled, name]);
}
